import { FormattedMessage, useIntl } from 'react-intl';
import { cn } from '@/helpers/classnames';
import { Skeleton } from './Skeleton';
import { useTravellerCreditInfo } from '@/hooks/useTravellerCreditInfo';
import { TravellerWithCollectionMembershipsDTO } from '@/api/trafikportalen';
import { IconSmartphoneDevice } from '@/icons/CoreIcons';
import { IconSmartcard } from '@/icons/Icons';

export const TravellerCreditInfo = ({
  traveller,
  className,
}: {
  traveller: TravellerWithCollectionMembershipsDTO;
  className?: string;
}) => {
  const { locale } = useIntl();
  const { allpayCredit, cardCredit, isLoading } =
    useTravellerCreditInfo(traveller);

  if (isLoading) return <Skeleton />;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <h3 className="w-full">
        <FormattedMessage defaultMessage="Resenärens kredit" />
      </h3>

      <div className="flex flex-wrap gap-4">
        <div className="flex flex-col gap-2 rounded-md border p-3">
          <div className="flex items-center gap-2">
            <IconSmartphoneDevice size={36} className="text-allpay" />
            {allpayCredit.toLocaleString(locale)}
            <span className="text-base font-normal text-text-700">
              <FormattedMessage defaultMessage="SEK" />
            </span>
          </div>
          <p>
            <FormattedMessage defaultMessage="Tjänsteresa i app" />
          </p>
        </div>
        <div className="flex flex-col gap-2 rounded-md border p-3">
          <div className="flex items-center gap-2">
            <IconSmartcard size={36} className="text-smartcard" />
            {cardCredit.toLocaleString(locale)}
            <span className="text-base font-normal text-text-700">
              <FormattedMessage defaultMessage="SEK" />
            </span>
          </div>
          <p>
            <FormattedMessage defaultMessage="Tjänsteresa på kort" />
          </p>
        </div>
      </div>
    </div>
  );
};
